export const CONSTANTS = {
  KYBER: {
    PLAY_SUCCESS: 'Success, start your game to join this server!', // 200
  },

  MESSAGE: {
    DEBUG: 'Debug is on. Using fake data.',
    ERROR: '[ERROR]',
    LOADING: 'loading results...',
    API_ERROR: 'no results: kyber api error.',
    NO_RESULTS: 'no results.',
    KYBER_WELCOME: 'Welcome to the Custom Kyber API with filtering!',
  },

  METHOD: {
    GET: 'GET',
    POST: 'POST',
  },

  HEADER: {
    NAME: {
      CONTENT_TYPE: 'Content-Type',
    },
    VALUE: {
      APP_JSON: 'application/json',
    },
  },

  BUTTON: {
    CLOSE: 'Close',
    JOIN: 'Join',
  },
}